import React from "react";
import { getFlag } from "@/config/rdoFlags";
import { MaterialsModule } from "@/components/rdo/modules/MaterialsModule";
import { LegacyMaterialsSection } from "@/components/rdo/legacy/LegacyMaterialsSection";
import { normalizeFromRDOPAGE, toRDOPAGEPayload } from "@/domain/rdo/normalize";
import type { RDO } from "@/domain/rdo/schema";

interface MaterialsForRDOProps {
  legacyValue: any;                 // formato atual usado em RDO.tsx
  onLegacyChange: (v: any) => void; // setter do RDO.tsx
  mode: "edit" | "view";
}

export function MaterialsForRDO({
  legacyValue,
  onLegacyChange,
  mode
}: MaterialsForRDOProps) {
  // Se a flag estiver desligada, usar o componente legado
  if (!getFlag("useNewMaterialsInRDO")) {
    return (
      <LegacyMaterialsSection 
        materialsData={legacyValue || { received: [], used: [] }}
        onAdd={onLegacyChange}
        isEditable={mode === "edit"}
      />
    );
  }

  // Se a flag estiver ligada, usar o novo módulo unificado
  
  // 1) Converte do formato legado -> RDO (apenas materiais)
  const partialRdo = normalizeFromRDOPAGE({ 
    materials: legacyValue,
    // Adicionar campos obrigatórios mínimos
    id: "",
    obraId: "",
    date: "",
    workforce: [],
    equipment: [],
    activities: [],
    occurrences: [],
    comments: [],
    photos: [],
    videos: [],
    attachments: [],
    weather: undefined,
    status: "draft",
    createdAt: "",
    updatedAt: ""
  });

  // 2) Renderiza o módulo novo com a UX do PreenchendoRDO
  return (
    <MaterialsModule
      value={partialRdo.materials}
      mode={mode === "edit" ? "edit" : "view"}
      onChange={(materials) => {
        // 3) Converte de volta para o payload legado esperado pelo RDO.tsx
        const payload = toRDOPAGEPayload({ 
          ...partialRdo, 
          materials
        });
        onLegacyChange(payload.materials);
      }}
    />
  );
}